import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { KanjiGraphEngine } from "./engine";

var root_3 = $.from_html(`<span class="tag"> </span>`);
var root_4 = $.from_html(`<button class="action-btn delete">Remove</button>`);
var root_5 = $.from_html(`<button class="action-btn expand">Expand</button>`);
var root_6 = $.from_html(`<div class="loader">Loading...</div>`);
var root_8 = $.from_html(`<div class="api-details"><p><strong>Meanings:</strong> </p> <p><strong>On:</strong> </p> <p><strong>Kun:</strong> </p></div>`);
var root_2 = $.from_html(`<div class="info-panel"><div class="info-header"><div class="info-title"><span class="kanji-large"> </span> <span> </span></div> <button class="close-btn">×</button></div> <div class="info-content"><div class="radicals"><span class="label">Components:</span> <div class="tags"></div></div> <!> <hr/> <!></div></div>`);
var root_1 = $.from_html(`<div class="app-container"><canvas class="graph-canvas"></canvas> <div class="search-panel"><form class="search-form"><input type="text" placeholder="Search Kanji (e.g. 亜)" maxlength="1"/> <button type="submit">Go</button></form></div> <!> <div class="kanji-counter"> </div></div>`);

export default function App($$anchor, $$props) {
	$.push($$props, true);

	const STORAGE_KEY = "kanji-graph-roots";
	let htmlCanvas = $.state(null);
	let htmlContainer = $.state(null);
	let data = $.state(null);
	let inputText = $.state("" // Clear default, we load from storage
	);
	let selectedNode = $.state(null // Removed type annotation in generic to fix Svelte parsing if strict
	);
	let apiData = $.state(null);
	let loadingApi = $.state(false);
	let engine = $.state(null);
	let isEngineReady = $.state(false);
	let graphStats = $.state($.proxy({ active: 0, total: 0 }));

	// Track active roots for persistence
	let activeRoots = $.state($.proxy(new Set()));

	// --- 1. Load Persistence on Init ---
	function loadPersistedState() {
		try {
			const saved = localStorage.getItem(STORAGE_KEY);

			if (saved) {
				const parsed = JSON.parse(saved);

				if (Array.isArray(parsed) && parsed.length > 0) {
					$.set(activeRoots, new Set(parsed), true);

					return;
				}
			}
		} catch(e) {
			console.warn("Failed to load graph state", e);
		}

		// Default fallback if storage is empty
		$.set(activeRoots, new Set(["星"]), true);
	}

	// --- 2. Save Persistence Helper ---
	function saveState() {
		try {
			localStorage.setItem(STORAGE_KEY, JSON.stringify([...$.get(activeRoots)]));
		} catch(e) {
			console.error("Failed to save state", e);
		}
	}

	$.user_effect(() => {
		fetch($$props.url).then((res) => res.json()).then((res) => {
			$.set(data, res, true);
			loadPersistedState(); // Load saved roots once data is fetched
		});
	});

	$.user_effect(() => {
		if (!$.get(htmlCanvas) || !$.get(data) || !$.get(htmlContainer)) return;

		const instance = new KanjiGraphEngine($.get(htmlCanvas), $.get(data));

		instance.onNodeSelect = (node) => {
			$.set(selectedNode, node, true);
		};

		instance.onStatsUpdate = (active, total) => {
			$.set(graphStats, { active, total }, true);
		};

		instance.onReady = () => {
			$.set(isEngineReady, true);

			// RESTORE: Expand all nodes found in localStorage
			if ($.get(activeRoots).size > 0) {
				$.get(activeRoots).forEach((root) => instance.expandNode(root));
			}
		};

		instance.init().catch((e) => console.error("Engine Init Failed", e));

		const resizeObserver = new ResizeObserver(() => instance.resize());

		resizeObserver.observe($.get(htmlContainer));
		$.set(engine, instance, true);

		return () => {
			resizeObserver.disconnect();
			instance.destroy();
			$.set(engine, null);
			$.set(isEngineReady, false);
		};
	});

	async function fetchApiData(kanji) {
		$.set(loadingApi, true);
		$.set(apiData, null);

		try {
			const res = await fetch(`https://kanjiapi.dev/v1/kanji/${encodeURIComponent(kanji)}`);

			if (res.ok) {
				$.set(apiData, await res.json(), true);
			}
		} catch(e) {
			console.error(e);
		} finally {
			$.set(loadingApi, false);
		}
	}

	$.user_effect(() => {
		if ($.get(selectedNode)) {
			fetchApiData($.get(selectedNode).id);
		} else {
			$.set(apiData, null);
		}
	});

	function handleSearch(e) {
		e.preventDefault();

		if (!$.get(engine) || !$.get(isEngineReady) || !$.get(inputText)) return;

		if ($.get(data) && !$.get(data)[$.get(inputText)]) {
			alert("Kanji not found in local dataset");

			return;
		}

		// Update Engine
		$.get(engine).promoteToRoot($.get(inputText));

		// Update Persistence & Reactivity
		// FIX: Create a new Set to trigger Svelte reactivity
		$.set(activeRoots, new Set($.get(activeRoots).add($.get(inputText))), true);

		saveState();
		$.set(inputText, "");
	}

	// --- 3. UI Reactivity Fix ---
	function toggleNodeStatus(targetStatus) {
		if (!$.get(selectedNode) || !$.get(engine)) return;

		const id = $.get(selectedNode).id;
		const nodeSnapshot = { ...$.get(selectedNode) };

		// FIX: Clone the set to ensure reassignment triggers UI update
		const nextRoots = new Set($.get(activeRoots));

		if (targetStatus === "visible") {
			$.get(engine).promoteToRoot(id);
			nextRoots.add(id);
		} else {
			$.get(engine).hideNode(id);
			nextRoots.delete(id);
		}

		// Reassign to trigger update
		$.set(activeRoots, nextRoots, true);

		saveState();

		// 2. Force the UI to use our snapshot with the updated status
		$.set(selectedNode, { ...nodeSnapshot, status: targetStatus }, true);
	}

	function handleDeselect() {
		$.set(selectedNode, null);
		$.get(engine)?.clearSelection();
	}

	var div = root_1();
	var canvas = $.child(div);

	$.bind_this(canvas, ($$value) => $.set(htmlCanvas, $$value), () => $.get(htmlCanvas));

	var div_1 = $.sibling(canvas, 2);
	var form = $.child(div_1);
	var input = $.child(form);

	$.remove_input_defaults(input);

	var button = $.sibling(input, 2);

	$.reset(form);
	$.reset(div_1);

	var node_1 = $.sibling(div_1, 2);

	{
		var consequent_3 = ($$anchor) => {
			var div_2 = root_2();
			var div_3 = $.child(div_2);
			var div_4 = $.child(div_3);
			var span = $.child(div_4);
			var text = $.child(span, true);

			$.reset(span);

			var span_1 = $.sibling(span, 2);
			let classes;
			var text_1 = $.child(span_1, true);

			$.reset(span_1);
			$.reset(div_4);

			var button_1 = $.sibling(div_4, 2);

			button_1.__click = handleDeselect;
			$.reset(div_3);

			var div_5 = $.sibling(div_3, 2);
			var div_6 = $.child(div_5);
			var div_7 = $.sibling($.child(div_6), 2);

			$.each(div_7, 21, () => $.get(selectedNode).radicals, $.index, ($$anchor, r) => {
				var span_2 = root_3();
				var text_2 = $.child(span_2, true);

				$.reset(span_2);
				$.template_effect(() => $.set_text(text_2, $.get(r)));
				$.append($$anchor, span_2);
			});

			$.reset(div_7);
			$.reset(div_6);

			var node_2 = $.sibling(div_6, 2);

			{
				var consequent = ($$anchor) => {
					var button_2 = root_4();

					button_2.__click = () => toggleNodeStatus("shadow");
					$.append($$anchor, button_2);
				};

				var alternate = ($$anchor) => {
					var button_3 = root_5();

					button_3.__click = () => toggleNodeStatus("visible");
					$.append($$anchor, button_3);
				};

				$.if(node_2, ($$render) => {
					if ($.get(selectedNode).status === "visible") $$render(consequent); else $$render(alternate, false);
				});
			}

			var node_3 = $.sibling(node_2, 4);

			{
				var consequent_1 = ($$anchor) => {
					var div_8 = root_6();

					$.append($$anchor, div_8);
				};

				var alternate_1 = ($$anchor) => {
					var fragment = $.comment();
					var node_4 = $.first_child(fragment);

					{
						var consequent_2 = ($$anchor) => {
							var div_9 = root_8();
							var p = $.child(div_9);
							var text_3 = $.sibling($.child(p));

							$.reset(p);

							var p_1 = $.sibling(p, 2);
							var text_4 = $.sibling($.child(p_1));

							$.reset(p_1);

							var p_2 = $.sibling(p_1, 2);
							var text_5 = $.sibling($.child(p_2));

							$.reset(p_2);
							$.reset(div_9);

							$.template_effect(
								($0, $1, $2) => {
									$.set_text(text_3, ` ${$0 ?? ''}`);
									$.set_text(text_4, ` ${$1 ?? ''}`);
									$.set_text(text_5, ` ${$2 ?? ''}`);
								},
								[
									() => $.get(apiData).meanings.slice(0, 3).join(", "),
									() => $.get(apiData).on_readings.join("、"),
									() => $.get(apiData).kun_readings.join("、")
								]
							);

							$.append($$anchor, div_9);
						};

						$.if(
							node_4,
							($$render) => {
								if ($.get(apiData)) $$render(consequent_2);
							},
							true
						);
					}

					$.append($$anchor, fragment);
				};

				$.if(node_3, ($$render) => {
					if ($.get(loadingApi)) $$render(consequent_1); else $$render(alternate_1, false);
				});
			}

			$.reset(div_5);
			$.reset(div_2);

			$.template_effect(() => {
				$.set_text(text, $.get(selectedNode).id);
				classes = $.set_class(span_1, 1, 'status-badge', null, classes, { shadow: $.get(selectedNode).status === "shadow" });
				$.set_text(text_1, $.get(selectedNode).status);
			});

			$.append($$anchor, div_2);
		};

		$.if(node_1, ($$render) => {
			if ($.get(selectedNode)) $$render(consequent_3);
		});
	}

	var div_10 = $.sibling(node_1, 2);
	var text_6 = $.child(div_10);

	$.reset(div_10);
	$.reset(div);
	$.bind_this(div, ($$value) => $.set(htmlContainer, $$value), () => $.get(htmlContainer));

	$.template_effect(() => {
		button.disabled = !$.get(isEngineReady);
		$.set_text(text_6, `${$.get(graphStats).active ?? ''} / ${$.get(graphStats).total ?? ''}`);
	});

	$.event('submit', form, handleSearch);
	$.bind_value(input, () => $.get(inputText), ($$value) => $.set(inputText, $$value));
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click']);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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